import React from 'react'

class EveAlarm extends React.Component {
  render(){
    return(
      <div>
        <h1>EveAlarm</h1>
          EveAlarmはアラーム音声をアップロード・ダウンロードできる目覚ましアプリです。<br/>
          お問い合わせは、mailerserver00@gmail.com までお願いします。<br/>

        <h2>EveAlarm -プライバシーポリシー-</h2>
          <h4>はじめに</h4>
            以下はSota Iwahashi（以下，当方）が提供する<br/>
            スマートフォン用アプリケーション（以下「本アプリケーション」）における<br/>
            利用者情報の取り扱いを定めたものです。<br/>
          
          <h4>収集する情報</h4>
            本アプリケーションのご利用に際して、以下の利用者情報を取得いたします。
            
            <h5>アプリケーションの利用状況の収集</h5>
              利用状況解析のためにCrashlyticsを使用する場合がございます。<br/>
          
            <ul>
              <li>Crashlytics（Google Inc.）</li>
            </ul>
            <br/>

            <h5>お問い合わせやご意見を頂く際の個人情報の収集</h5>
            <ul>
                <li>問い合わせ欄に入力されたお名前</li>
                <li>送信元のメールアドレス</li>
                <li>お問い合わせ内容</li>
            </ul>

            <h5>利用目的</h5>
              当方は、お問い合わせにおいて収集した情報を、そのお問い合わせに対する返信のために利用いたします。<br/>
              また、お問い合わせで収集した情報を、本アプリケーションの品質向上のために利用いたします。<br/>

            <h5>個人情報の管理</h5>
              当方は、お客さまの個人情報を正確かつ最新の状態に保ち、<br/>
              個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、<br/>
              安全対策を実施し個人情報の厳重な管理を行ないます。<br/>
              また、当方はユーザより入力された情報（テキスト、数字、添付した画像）などを<br/>
              当方利用のサーバーや外部サービスに送信・保存することは一切いたしません。<br/>
              ユーザが入力したデータは一切お預かりしないセキュリティ体制を敷いております。<br/>

            <h5>個人情報の第三者への開示・提供の禁止</h5>
              当方は、お客さまよりお預かりした個人情報を適切に管理し、<br/>
              次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。<br/>
            <ul>
              <li>お客さまの同意がある場合</li>
              <li>法令に基づき開示することが必要である場合</li>
            </ul>

            <h5>法令、規範の遵守と見直し</h5>
              当方は、保有する個人情報に関して適用される日本の法令、<br/>
              その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。<br/>

            <h5>お問い合わせ</h5>
              アプリに関するお問い合わせはmailerserver00@gmail.comへ、お名前、お問い合わせ概要・内容を記載してお送り下さい。<br/>
              追って3営業日以内にご返答させて頂きます。<br/>

        <h4>アラーム音声について</h4>
          <h5>アラーム音声のダウンロードについて</h5>
            当アプリケーション内で入手可能な音声は当アプリケーション内にのみにおいて、お客様はご自由にご利用することができます。<br/>
          <h5>アラーム音声のアップロードについて</h5>
            お客様がアップロードすることの出来る音声はお客様自身が著作権を所有しているもの、もしくは著作権フリーの音声に限られます。<br/>
            お客様が当アプリケーション内でアップロードした音声について、アップロードしたお客様があらゆる責任を持ち、万が一他者の権利を侵害していた場合はその責任を問われる可能性があります。<br/>
            お客様が当アプリケーション内でアップロードした音声について、当アプリケーションのプライパシーポリシーに同意したものとします。<br/>
            お客様が当アプリケーション内でアップロードした音声は、当アプリケーション内でのみ利用されます。<br />
            万が一、お客様が当アプリケーション内でアップロードした音声が当アプリケーションのプライパシーポリシー内で規定している範囲を出て利用されている場合、<br />
            アップロードしたお客様は不正利用しているお客様に対して責任を問うことができます。<br />

        <h4>本プライバシーポリシーの改定について</h4>
          当方は当アプリケーションのこのプライバシーポリシーを改定する権利を持ちます。<br />
          改定された場合、その都度お客様側でご確認ください。<br />
          本プライバシーポリシーに同意しない場合、お客様側からの要望により当アプリケーションの提供するサービスの利用を停止するものとします。<br />
      </div>
    )
  }
}

export default EveAlarm;